import { Link } from 'react-router-dom';

export default function MarketAnalysisPage() {
  return (
    <div className="min-h-screen bg-white">
      {/* Header */}
      <div className="bg-gradient-to-br from-blue-500 to-blue-600 text-white py-20">
        <div className="max-w-4xl mx-auto px-6 lg:px-8">
          <Link 
            to="/"
            className="inline-flex items-center gap-2 text-white/90 hover:text-white mb-8 transition-colors whitespace-nowrap"
          >
            <i className="ri-arrow-left-line"></i>
            Back to home
          </Link>
          
          <div className="flex items-center gap-4 mb-6">
            <div className="w-16 h-16 rounded-xl bg-white/20 backdrop-blur-sm flex items-center justify-center">
              <i className="ri-bar-chart-box-line text-3xl"></i>
            </div>
            <h1 className="text-5xl font-bold">Market Analysis</h1>
          </div>
          
          <p className="text-xl text-white/90 leading-relaxed">
            Understand industry landscapes and competitive positioning with comprehensive market intelligence.
          </p>
        </div>
      </div>

      {/* Content */}
      <div className="max-w-4xl mx-auto px-6 lg:px-8 py-16">
        <div className="prose prose-lg max-w-none">
          <h2 className="text-3xl font-bold text-slate-900 mb-6">What is Market Analysis?</h2>
          <p className="text-slate-600 leading-relaxed mb-8">
            Our Market Analysis service provides you with deep insights into your industry landscape, helping you understand market dynamics, competitive positioning, and emerging opportunities. We combine data-driven research with expert analysis to give you a comprehensive view of your market environment.
          </p>

          <h2 className="text-3xl font-bold text-slate-900 mb-6">Key Features</h2>
          <div className="space-y-6 mb-12">
            <div className="flex gap-4">
              <div className="w-12 h-12 rounded-lg bg-blue-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-line-chart-line text-xl text-blue-600"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold text-slate-900 mb-2">Industry Trends Analysis</h3>
                <p className="text-slate-600 leading-relaxed">
                  Stay ahead of the curve with real-time insights into industry trends, market shifts, and emerging patterns that could impact your business strategy.
                </p>
              </div>
            </div>

            <div className="flex gap-4">
              <div className="w-12 h-12 rounded-lg bg-blue-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-team-line text-xl text-blue-600"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold text-slate-900 mb-2">Competitive Intelligence</h3>
                <p className="text-slate-600 leading-relaxed">
                  Gain a clear understanding of your competitive landscape, including competitor strategies, market positioning, and potential threats and opportunities.
                </p>
              </div>
            </div>

            <div className="flex gap-4">
              <div className="w-12 h-12 rounded-lg bg-blue-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-pie-chart-line text-xl text-blue-600"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold text-slate-900 mb-2">Market Segmentation</h3>
                <p className="text-slate-600 leading-relaxed">
                  Identify and analyze key market segments, customer demographics, and target audience characteristics to refine your go-to-market strategy.
                </p>
              </div>
            </div>

            <div className="flex gap-4">
              <div className="w-12 h-12 rounded-lg bg-blue-100 flex items-center justify-center flex-shrink-0">
                <i className="ri-global-line text-xl text-blue-600"></i>
              </div>
              <div>
                <h3 className="text-xl font-bold text-slate-900 mb-2">Market Size & Growth Potential</h3>
                <p className="text-slate-600 leading-relaxed">
                  Understand the total addressable market, growth projections, and expansion opportunities to make informed investment decisions.
                </p>
              </div>
            </div>
          </div>

          <h2 className="text-3xl font-bold text-slate-900 mb-6">Benefits</h2>
          <ul className="space-y-3 mb-12">
            <li className="flex items-start gap-3">
              <i className="ri-check-line text-xl text-blue-600 mt-1"></i>
              <span className="text-slate-600">Make data-driven strategic decisions with confidence</span>
            </li>
            <li className="flex items-start gap-3">
              <i className="ri-check-line text-xl text-blue-600 mt-1"></i>
              <span className="text-slate-600">Identify new market opportunities before your competitors</span>
            </li>
            <li className="flex items-start gap-3">
              <i className="ri-check-line text-xl text-blue-600 mt-1"></i>
              <span className="text-slate-600">Optimize your market positioning and differentiation strategy</span>
            </li>
            <li className="flex items-start gap-3">
              <i className="ri-check-line text-xl text-blue-600 mt-1"></i>
              <span className="text-slate-600">Reduce market entry risks with comprehensive intelligence</span>
            </li>
            <li className="flex items-start gap-3">
              <i className="ri-check-line text-xl text-blue-600 mt-1"></i>
              <span className="text-slate-600">Align your business strategy with market realities</span>
            </li>
          </ul>

          <div className="bg-slate-50 rounded-2xl p-8 mt-12">
            <h2 className="text-2xl font-bold text-slate-900 mb-4">Ready to Get Started?</h2>
            <p className="text-slate-600 mb-6">
              Let us help you gain a competitive edge with comprehensive market analysis tailored to your business needs.
            </p>
            <Link 
              to="/"
              onClick={(e) => {
                e.preventDefault();
                window.REACT_APP_NAVIGATE('/');
                setTimeout(() => {
                  const element = document.getElementById('contact');
                  if (element) {
                    const offset = 80;
                    const elementPosition = element.getBoundingClientRect().top;
                    const offsetPosition = elementPosition + window.pageYOffset - offset;
                    window.scrollTo({
                      top: offsetPosition,
                      behavior: 'smooth'
                    });
                  }
                }, 100);
              }}
              className="inline-flex items-center gap-2 bg-blue-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors whitespace-nowrap cursor-pointer"
            >
              Contact Us
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
